import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import InfoSheetBase from './InfoSheetBase';

interface IProps extends StateProps, DispatchProps, RouteComponentProps {
  match: any;
}

const ViewAuditionInfoSheet: React.FC<IProps> = ({
  history,
  match,
  auditionInfoSheet,
  getAuditionInfoSheet
}) => {
  const [infoSheet, setInfoSheet] = useState({});

  useEffect(() => {
    const { auditionScheduleId, infoSheetId } = match.params;
    const fetchAuditionInfoSheet = async () => {
      try {
        await getAuditionInfoSheet({
          infoSheetId,
          auditionScheduleId,
        });
      } catch (e) {
        history.push('/500');
      }
    };

    fetchAuditionInfoSheet();
  }, [getAuditionInfoSheet, history, match.params]);

  useEffect(() => {
    if (Object.keys(auditionInfoSheet).length) {
      setInfoSheet(auditionInfoSheet);
    }
  }, [auditionInfoSheet]);

  return (
    <InfoSheetBase
      auditionInfoSheet={infoSheet}
      onChange={(newInfoSheet: any) => setInfoSheet(newInfoSheet)}
    />
  );
};

interface StateProps {
  auditionInfoSheet: any;
}

const mapStateToProps = (state: any) => ({
  auditionInfoSheet: state.kiosk.auditionInfoSheet
});

interface DispatchProps {
  getAuditionInfoSheet: ({ infoSheetId, auditionScheduleId }: any) => void;
}

const mapDispatchToProps = (dispatch: any) => ({
  getAuditionInfoSheet: dispatch.kiosk.getAuditionInfoSheet,
});

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(ViewAuditionInfoSheet));
